import { chrome } from '@/lib/content';
import { GERMANY_NAV, SWISS_ORIGIN } from '@/lib/markets';
import SmartLink from './SmartLink';

/** Same brand and Swiss operating entity, with Germany-specific navigation. */
export default function GermanyFooter() {
  const { address } = chrome.footer;
  return (
    <footer className="hp-footer" id="footer-kontakt">
      <div className="hp-footer__body">
        <div className="hp-container hp-footer__inner">
          <div className="hp-footer__col hp-footer__col--brand">
            <SmartLink to="/de-de" className="hp-footer__brand" aria-label="Health Prime Deutschland">
              <img className="hp-footer__logo" src={chrome.brand.logo} alt={chrome.brand.name} width={778} height={124} />
            </SmartLink>
            <address className="hp-footer__address">
              <span className="hp-footer__company">{address.company}</span>
              <span>{address.street}</span><span>{address.city}</span><span>Schweiz</span>
              <a className="hp-footer__contact-link" href={`mailto:${address.email}`}>{address.email}</a>
              <a className="hp-footer__contact-link" href="tel:+41442502871">+41 44 250 28 71</a>
              <a className="hp-footer__contact-link" href={chrome.contact.whatsapp} target="_blank" rel="noopener noreferrer">WhatsApp Chat</a>
            </address>
          </div>
          <nav className="hp-footer__col" aria-label="BGM Deutschland">
            <h2 className="hp-footer__title hp-h6">BGM Deutschland</h2>
            <ul className="hp-footer__links">
              {GERMANY_NAV.map((item) => <li key={item.href}><SmartLink className="hp-footer__link" to={item.href}>{item.label}</SmartLink></li>)}
            </ul>
          </nav>
          <nav className="hp-footer__col" aria-label="Unternehmen">
            <h2 className="hp-footer__title hp-h6">Unternehmen</h2>
            <ul className="hp-footer__links">
              <li><SmartLink className="hp-footer__link" to={SWISS_ORIGIN + '/referenzen'}>Referenzen</SmartLink></li>
              <li><SmartLink className="hp-footer__link" to={SWISS_ORIGIN + '/ueber-uns'}>Über Uns</SmartLink></li>
              <li><SmartLink className="hp-footer__link" to={SWISS_ORIGIN + '/'}>Website Schweiz</SmartLink></li>
            </ul>
          </nav>
          <nav className="hp-footer__col" aria-label="Rechtliche Informationen">
            <h2 className="hp-footer__title hp-h6">Rechtliche Informationen</h2>
            <ul className="hp-footer__links">
              <li><SmartLink className="hp-footer__link" to={SWISS_ORIGIN + '/impressum'}>Impressum der Health Prime AG</SmartLink></li>
              <li><SmartLink className="hp-footer__link" to={SWISS_ORIGIN + '/datensicherheit'}>Datenschutzerklärung</SmartLink></li>
              <li><SmartLink className="hp-footer__link" to="/de-de/datenschutz-bgm">Datenschutz im BGM</SmartLink></li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}
